<template>
  <div style="margin-top: 20px">
    <div class="top-fluid text-left" v-if="current != 3">
      <!-- <button class="switch" v-for="(item,index) in list" :key="index" :class="{active: current == index}"
        @click='tabToggle(index)'>{{item}}</button> -->
      <ul class="nav nav-tabs">
        <li
          role="presentation"
          v-for="(item, index) in List"
          :key="index"
          :class="{ active: current == index }"
          @click="changeActive(item, index)"
        >
          <a href="javascript:;">{{ item.text }}</a>
        </li>
      </ul>
      <!-- <button class="switch">社会组织</button>
      <button class="switch">个人</button> -->
    </div>

    <div class="container-fluid text-left" v-if="current == 0">
      <div class="col-12">
        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">组织名称</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写组织名称"
              name=""
              id=""
              v-model="ClusterTitle"
            />
          </div>
        </div>
        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">联系姓名</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写联系姓名"
              name=""
              id=""
              v-model="ClusterName"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">联系电话</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写联系电话"
              name=""
              id=""
              v-model="ClusterTel"
              @change="check"
            />
          </div>
          <p v-if="err" style="color: red; margin: 0">手机号码不正确</p>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">联系地址</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写联系地址"
              name=""
              id=""
              v-model="ClusterAdd"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">服务范围</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写服务范围"
              name=""
              id=""
              v-model="ClusterRange"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10">
          <div class="col-3 middle col-00">
            <h4 class="z_15">组织简介</h4>
          </div>
          <div class="col-12 middle col-00">
            <textarea
              rows="5"
              class="input-group"
              style="overflow: auto; display: block"
              placeholder="请填写组织简介"
              v-model="ClusterExplain"
            ></textarea>
            <!-- <textarea rows="5" class="input-group" style="overflow: hidden;" placeholder="描述您的需求内容"
              v-model="ClusterExplain"></textarea> -->
          </div>
        </div>

        <div class="row tt_x_10 tt_10">
          <div class="col-6 col-00 middle text-left">
            <h4 class="z_15">组织LOGO</h4>
          </div>
          <div class="col-12 middle col-00">
            <label class="label111">
              <input
                type="file"
                style="display: none"
                ref="adFile"
                @change="adChange"
              />
              <div class="imgs" v-if="editImg != ''">
                <img :src="editImg" alt="" style="width: 100%" />
              </div>
              <div class="add_btn" v-else></div>
            </label>
          </div>
        </div>

        <div class="col-12">
          <button class="submit_btn" @click="Clusterbtn(current)">
            提交认证申请
          </button>
        </div>
      </div>
      <div style="margin-top: 20px">
        <input
          type="checkbox"
          style="vertical-align: middle; margin-top: -2px"
          v-model="checkVal"
        />
        同意本平台的<span
          @click="$router.push({ name: 'help_clause', query: { id: 6 } })"
          ><a style="color: blue">《入驻协议》</a></span
        >
      </div>
      <div id="d_p_80"></div>
    </div>
    <div class="container-fluid text-left" v-if="current == 1">
      <div class="col-12">
        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">组织名称</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写组织名称"
              name=""
              id=""
              v-model="SociologyTitle"
            />
          </div>
        </div>
        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">联系姓名</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写联系姓名"
              name=""
              id=""
              v-model="SociologyName"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">联系电话</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写联系电话"
              name=""
              id=""
              v-model="SociologyTel"
              @change="check1"
            />
          </div>
          <p v-if="err1" style="color: red; margin: 0">手机号码不正确</p>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">联系地址</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写联系地址"
              name=""
              id=""
              v-model="SociologyAdd"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">服务范围</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写服务范围"
              name=""
              id=""
              v-model="SociologyRange"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10">
          <div class="col-3 middle col-00">
            <h4 class="z_15">组织简介</h4>
          </div>
          <div class="col-12 middle col-00">
            <textarea
              rows="5"
              class="input-group"
              style="overflow: auto; display: block"
              placeholder="请填写组织简介"
              v-model="SociologyExplain"
            ></textarea>
          </div>
        </div>

        <div class="row tt_x_10 tt_10">
          <div class="col-6 col-00 middle text-left">
            <h4 class="z_15">组织LOGO</h4>
          </div>
          <div class="col-12 middle col-00">
            <label class="label111">
              <input
                type="file"
                style="display: none"
                ref="adFile1"
                @change="adChange1"
              />
              <div class="imgs" v-if="editImg1 != ''">
                <img :src="editImg1" alt="" style="width: 100%" />
              </div>

              <div class="add_btn" v-else></div>
            </label>
          </div>
        </div>

        <div class="col-12">
          <button class="submit_btn" @click="Clusterbtn(current)">
            提交认证申请
          </button>
        </div>
      </div>
      <div style="margin-top: 20px">
        <input
          type="checkbox"
          style="vertical-align: middle; margin-top: -2px"
          v-model="checkVal2"
        />
        同意本平台的<span
          @click="$router.push({ name: 'help_clause', query: { id: 6 } })"
          ><a style="color: blue">《入驻协议》</a></span
        >
        <!-- <input name="Fruit" type="radio" value="同意本平台的发布协议" />同意本平台的<span
          @click="$router.push({name:'help_clause',query:{id:7}})">发布协议</span> -->
      </div>
      <div id="d_p_80"></div>
    </div>
    <div class="container-fluid text-left" v-if="current == 2">
      <div class="col-12">
        <!-- <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">个人名称</h4>
          </div>
          <div class="col-9 middle col-00">
            <input class="z_15" type="text" placeholder="填写求助者的联系电话" name="" id="" value="" />
          </div>
        </div> -->
        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">联系姓名</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写联系姓名"
              name=""
              id=""
              v-model="name"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">联系电话</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写联系电话"
              name=""
              id=""
              v-model="tel"
              @change="check2"
            />
          </div>
          <p v-if="err2" style="color: red; margin: 0">手机号码不正确</p>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">联系地址</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写联系地址"
              name=""
              id=""
              v-model="address"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">服务范围</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="请填写服务范围"
              name=""
              id=""
              v-model="range"
            />
          </div>
        </div>
        <!--
        <div class="row  tt_x_10 tt_10">
          <div class="col-3 middle col-00">
            <h4 class="z_15">个人简介</h4>
          </div>
          <div class="col-12 middle col-00">
            <textarea rows="5" class="input-group" placeholder="描述您的需求内容"></textarea>
          </div>
        </div> -->

        <div class="row tt_x_10 tt_10">
          <div class="col-6 col-00 middle text-left">
            <h4 class="z_15">个人头像</h4>
          </div>
          <div class="col-12 middle col-00">
            <label class="label111">
              <input
                type="file"
                style="display: none"
                ref="adFile2"
                @change="adChange2"
              />
              <div class="imgs" v-if="editImg2 != ''">
                <img :src="editImg2" alt="" style="width: 100%" />
              </div>
              <div class="add_btn" v-else></div>
            </label>
          </div>
        </div>

        <div class="col-12">
          <button class="submit_btn" @click="Clusterbtn(current)">
            提交认证申请
          </button>
        </div>
      </div>
      <div style="margin-top: 20px">
        <input
          type="checkbox"
          style="vertical-align: middle; margin-top: -2px"
          v-model="checkVal2"
        />
        同意本平台的<span
          @click="$router.push({ name: 'help_clause', query: { id: 6 } })"
          ><a style="color: blue">《入驻协议》</a></span
        >
        <!-- <input name="Fruit" type="radio" value="同意本平台的发布协议" />同意本平台的<span
          @click="$router.push({name:'help_clause',query:{id:7}})">发布协议</span> -->
      </div>
      <div id="d_p_80"></div>
    </div>
    <div class="container-fluid text-left" v-if="current == 3">
      <div style="text-align: center; line-height: 40px; margin-top: 30vh">
        <h4>认证成功</h4>
        <h5 style="margin-top: 8vh">
          <span
            class="label label-primary label_50"
            style="
              border-radius: 50px/50px;
              background-color: #ffd986;
              color: #00a4b7;
            "
            >V</span
          >{{ rz_title | name }}
        </h5>
      </div>
    </div>
    <div class="pop" v-show="show" @touchmove.prevent></div>

    <div class="edit2" v-show="show">
      <div class="text-center ddd" style="border-bottom: 1px solid #f7f8f9">
        <h4 class="message">操作成功,{{ time }}等待系统审核资料</h4>
        <!-- <h4></h4> -->

        <!-- <button @click="edit">前往</button> -->
      </div>
      <div style="text-align: center" @click="edit">
        <button>确定</button>
      </div>
    </div>
    <pop :show5="show5" message="请正确填写所有信息" @editshow="editshow1" />
  </div>
</template>

<script>
import pop from "./popup.vue";
export default {
  data() {
    return {
      checkVal: false,
      checkVal1: false,
      checkVal2: false,
      show5: false,
      show: false,
      avatar_url: null,
      avatar_url2: "",
      avatar_url3: "",
      r_id: 0,
      err: 0,
      err1: 0,
      err2: 0,
      List: [
        {
          text: "群团组织",
          isActive: true,
        },
        {
          text: "社会组织",
          isActive: false,
        },
        {
          text: "个人",
          isActive: false,
        },
      ],
      rz_title: "",
      navlist: ["群团组织", "社会组织", "个人"],
      current: 0,
      ClusterExplain: "",
      ClusterRange: "",
      ClusterAdd: "",
      ClusterTel: this.$api.getUserInfo().telephone,
      ClusterName: this.$api.getUserInfo().username,
      ClusterTitle: "",
      editImg: "",
      editImg1: "",
      editImg2: "",
      SociologyExplain: "",
      SociologyRange: "",
      SociologyAdd: "",
      SociologyTel: this.$api.getUserInfo().telephone,
      SociologyName: this.$api.getUserInfo().username,
      SociologyTitle: "",
      name: this.$api.getUserInfo().username,
      tel: this.$api.getUserInfo().telephone,
      address: "",
      range: "",
      editFiles: "",
      editFiles1: "",
      editFiles2: "",
      time: 5,
      timer: null,
    };
  },
  components: {
    pop,
  },
  mounted() {
    //查询用户；
    var info_id = this.$api.getUserInfo().id;
    this.$api
      .getAPI(
        "mutual/attribute/" +
          info_id +
          "?appid=202108&type_id=4001&redis_time=3",
        {}
      )
      .then((res) => {
        var db = res.data.data.models;
        if (res.data.data != null) {
          //如果审核通过
          console.log(db.state);
          console.log("sta22222te");
          if (db.state == 1) {
            this.current = 3;
          }
          console.log("state");
          console.log(db.state);

          //有数据
          console.log(db.length);
          console.log("console.log(db.length);");
          this.r_id = db.id;
          //判断所在组织

          console.log(db.key_id);
          var key_id = db.key_id;
          var address = db.address;
          var avatar_url = db.avatar_url;
          var title = db.title;
          var explain = db.explain;
          var range = db.range;
          //this.rz_title=db.company;
          if (key_id == 3) {
            //个人认证
            this.rz_title = db.username;
            //地址
            this.address = address;
            //范围
            this.range = range;
            //头像
            this.editImg2 = avatar_url;
          }
          if (key_id == 2) {
            //社会组织认证
            this.rz_title = title;
            //
            this.SociologyTitle = title;
            //地址
            this.SociologyAdd = address;
            //范围
            this.SociologyRange = range;
            //简介
            this.SociologyExplain = explain;
          }
          if (key_id == 1) {
            //ClusterTitle，ClusterAdd，ClusterRange，ClusterExplain
            //群团组织认证
            this.rz_title = title;
            //
            this.ClusterTitle = title;
            //地址
            this.ClusterAdd = address;
            //范围
            this.ClusterRange = range;
            //简介
            this.ClusterExplain = explain;
          }
        }
      });
  },
  methods: {
    editshow1() {
      this.show5 = false;
    },
    changeActive: function (data, id) {
      //alert(id);
      switch (id) {
        case 0:
          //this.$Message.warning("群团组织！")
          //alert("0")
          break;
        case 1:
          //this.$Message.info("群团组织！")
          //alert("1")
          break;
        case 2:
          //this.$Message.success("群团组织！")
          //alert("2")
          break;
      }
      this.current = id;
      data.isActive = !data.isActive;
    },
    check() {
      if (!/^1[34578]\d{9}$/.test(this.ClusterTel)) {
        this.err = 1;
        // console.log(1);
        return false;
      } else {
        this.err = 0;
      }
      // console.log(this.err);
    },
    check1() {
      if (!/^1[34578]\d{9}$/.test(this.SociologyTel)) {
        this.err1 = 1;
        // console.log(2);
        return false;
      } else {
        this.err1 = 0;
      }
    },
    check2() {
      if (!/^1[34578]\d{9}$/.test(this.tel)) {
        this.err2 = 1;
        // console.log(3);
        return false;
      } else {
        this.err2 = 0;
      }
    },
    Clusterbtn(current) {
      // console.log(current);
      var info_id = this.$api.getUserInfo().id;
      var r_server_url =
        "mutual/attribute/" + info_id + "?appid=202108&type_id=4001";
      // if (this.r_id > 0) {
      //   r_server_url = `mutual/attribute/${this.r_id}?appid=202108&type_id=4002&state=1`
      // }
      if (current == 0) {
        if (this.checkVal == false) {
          this.$Message.error("请勾选本平台《入驻协议》");
          return;
        }
        if (
          this.ClusterTitle != "" &&
          this.ClusterName != "" &&
          this.err != 1 &&
          this.ClusterAdd != "" &&
          this.ClusterRange != "" &&
          this.ClusterExplain != ""
        ) {
          let data = new FormData();
          data.append("key_id", 1);
          data.append("title", this.ClusterTitle);
          data.append("username", this.ClusterName);
          data.append("telephone", this.ClusterTel);
          data.append("address", this.ClusterAdd);
          data.append("range", this.ClusterRange);
          data.append("explain", this.ClusterExplain);
          data.append("openid", this.$api.getUserInfo().openid);
          data.append("avatar_url", this.avatar_url);
          this.$api.postAPI(r_server_url, data).then((res) => {
            console.log(res);
            //window.localStorage.setItem('openid', 336699)
            this.show = true;
            this.timer = setInterval(() => {
              this.time--;
              if (this.time < 1) {
                clearInterval(this.timer);
                this.timer = null;
                this.show = false;
                this.$router.push("/home_users");
              }
            }, 1000);
          });
        } else {
          //this.show5 = true
        }
      }
      if (current == 1) {
        if (this.checkVal1 == false) {
          this.$Message.error("请勾选本平台《入驻协议》");
          return;
        }
        if (
          this.SociologyTitle != "" &&
          this.SociologyName != "" &&
          this.err1 != 1 &&
          this.SociologyAdd != "" &&
          this.SociologyRange != "" &&
          this.SociologyExplain != ""
        ) {
          let data = new FormData();
          data.append("key_id", 2);
          data.append("title", this.SociologyTitle);
          data.append("username", this.SociologyName);
          data.append("telephone", this.SociologyTel);
          data.append("address", this.SociologyAdd);
          data.append("range", this.SociologyRange);
          data.append("explain", this.SociologyExplain);
          data.append("openid", this.$api.getUserInfo().openid);
          data.append("avatar_url", this.avatar_url2);
          this.$api.postAPI(r_server_url, data).then((res) => {
            console.log(res);
            //window.localStorage.setItem('openid', 666666)
            this.show = true;
            this.timer = setInterval(() => {
              this.time--;
              if (this.time < 1) {
                clearInterval(this.timer);
                this.timer = null;
                this.show = false;
                this.$router.push("/home_users");
              }
            }, 1000);
          });
        } else {
          //this.show5 = true
          this.$Message.error("请认真填写每项资料！");
        }
      }
      if (current == 2) {
        if (this.checkVal2 == false) {
          this.$Message.error("请勾选本平台《入驻协议》");
          return;
        }
        if (
          this.name != "" &&
          this.err2 != 1 &&
          this.address != "" &&
          this.range != "" &&
          this.avatar_url3 != ""
        ) {
          let data = new FormData();
          data.append("key_id", 3);
          data.append("username", this.name);
          data.append("telephone", this.tel);
          data.append("address", this.address);
          data.append("range", this.range);
          data.append("openid", this.$api.getUserInfo().openid);
          data.append("avatar_url", this.avatar_url3);
          this.$api.postAPI(r_server_url, data).then((res) => {
            console.log(res);
            this.show = true;
            this.timer = setInterval(() => {
              this.time--;
              if (this.time < 1) {
                clearInterval(this.timer);
                this.timer = null;
                this.show = false;
                this.$router.push("/home_users");
              }
            }, 1000);
          });
        } else {
          //this.show5 = true
          this.$Message.error("请认真填写每项资料！");
        }
      }
    },
    edit() {
      this.time = 0;
      clearInterval(this.timer);
      this.timer = null;
      this.show = false;
      this.$router.push("/home_users");
    },
    adChange(e) {
      console.log(e);
      console.log(this.$refs.adFile.files[0]);

      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      console.log(file);
      var reader = new FileReader();
      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        this.editImg = res.result;
      };
      reader.readAsDataURL(file);
      this.editFiles = file;
      console.log(this.editFiles);
      let formData = new FormData();
      formData.append("fileName", this.editFiles);
      // console.log(this.avatar_url);
      this.$api.postAPI(`default/upload/?state=1`, formData).then((res) => {
        this.avatar_url = res.data.url;
        console.log(this.avatar_url);
      });
    },
    adChange1(e) {
      console.log(e);
      console.log(this.$refs.adFile1.files[0]);

      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      console.log(file);
      var reader = new FileReader();
      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        this.editImg1 = res.result;
      };
      reader.readAsDataURL(file);
      this.editFiles1 = file;
      console.log(this.editFiles1);
      let formData = new FormData();
      formData.append("fileName", this.editFiles1);
      // console.log(this.avatar_url);
      this.$api.postAPI(`default/upload/?state=1`, formData).then((res) => {
        this.avatar_url2 = res.data.url;
        console.log(this.avatar_url2);
      });
    },
    adChange2(e) {
      console.log(e);
      console.log(this.$refs.adFile2.files[0]);

      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      console.log(file);
      var reader = new FileReader();
      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        this.editImg2 = res.result;
      };
      reader.readAsDataURL(file);
      this.editFiles2 = file;
      console.log(this.editFiles2);
      let formData = new FormData();
      formData.append("fileName", this.editFiles2);
      // console.log(this.avatar_url);
      this.$api.postAPI(`default/upload/?state=1`, formData).then((res) => {
        this.avatar_url3 = res.data.url;
        console.log(this.avatar_url3);
      });
    },
  },
  filters: {
    name(value) {
      if (!value) return "";
      let str = value;
      str = str
        .toString()
        .replace(/^([^\x00-\xff])([^\x00-\xff]{0,})([^\x00-\xff])/g, "$1*$3");
      return str;
    },
  },
};
</script>

<style>
.submit_btn {
  margin-top: 20px;
  bottom: 0;
  width: 100%;
  border: 0;
  text-align: center;
  line-height: 3em;
  font-size: 1em;
  color: #ffffff;
  background: #01b2c2;
  cursor: pointer;
  margin-left: 0;
  height: auto;
}

.ddd {
  min-height: 104px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.message {
  margin: 0;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  max-height: 60vh;
  /* line-height: 60px; */
  padding: 26px 24px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
  text-align: center;
  word-wrap: break-word;
  display: block;
}

.edit5 {
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 125px;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 20px;
  padding: 10px 20px;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}

.edit5 button {
  height: 35px;
  width: 150px;
  border-radius: 3px;
  border: none;
  background: #01b2c2;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
  margin: 6px auto 10px;
  /* margin-top: 25px; */
  text-align: center !important;
}

.pop {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 99;
}

.edit2 {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 152px;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 16px;
  padding: 0;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}

.edit2 button {
  height: 48px;
  line-height: 48px;
  width: 150px;
  border-radius: 3px;
  border: none;
  background: none !important;
  color: #01b2c2;
  /* margin-left: 10px; */
  cursor: pointer;
  margin: 0;
  padding-top: 0px;
  /* margin-top: 25px; */
  text-align: center !important;
}

/* .active {
  font-size: 16px !important;
  color: #1890ff !important;
} */
.top-fluid {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.switch {
  outline: none !important;
  margin-left: -6px;
  margin-right: 15px;
  background: none;
  color: #7b7b7b;
  border: none;
  font-size: 14px;
  text-align: left !important;
}

.col-00 {
  padding-right: 0px;
  padding-left: 0px;
}

textarea {
  padding: 8px;
  border: 1px dashed #e5e5e5;
}

.add_btn {
  width: 80px;
  height: 80px;
  border: 1px dashed #e5e5e5;
  background: url(https://img.hsnms.com/20211002/1633134897.png) no-repeat 50%
    50%;
  cursor: pointer;
}

.label111 {
  width: 100%;
  height: 80px;
}

.imgs {
  width: 80px;
  height: 80px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav a {
  color: #01b2c2;
}
</style>



// WEBPACK FOOTER //
// src/components/views/server_user_release.vue